var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppStoreIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_346",
    "data-name": "Group 346",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 225.297,
    height: 73.697,
    viewBox: "0 0 225.297 73.697",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_379",
    "data-name": "Rectangle 379",
    width: 225.297,
    height: 73.697,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M225.3,63.737a9.959,9.959,0,0,1-9.957,9.96H9.96A9.961,9.961,0,0,1,0,63.737V9.959A9.96,9.96,0,0,1,9.96,0H215.34A9.958,9.958,0,0,1,225.3,9.959Z",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M78.635,79.427a36.486,36.486,0,0,1-3.3,6.16c-2.143,3.262-5.163,7.325-8.9,7.359-3.326.031-4.179-2.164-8.692-2.139s-5.455,2.178-8.781,2.147c-3.742-.035-6.6-3.7-8.746-6.964C34.221,76.868,33.6,66.164,37.29,60.474c2.626-4.044,6.768-6.411,10.664-6.411,3.966,0,6.46,2.175,9.739,2.175,3.181,0,5.12-2.179,9.7-2.179a12.941,12.941,0,0,1,9.755,5.151c-8.573,4.7-7.181,16.944,1.482,20.217",
    transform: "translate(-19.883 -30.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M91.514,34.775a11.134,11.134,0,0,0,2.472-8.245,12.028,12.028,0,0,0-7.764,4.176c-1.687,2.05-3.079,5.089-2.537,8.042a10.151,10.151,0,0,0,7.829-3.973",
    transform: "translate(-47.479 -15.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M167.024,68.6,158.441,93.86h3.931l2.562-7.758h8.31l2.635,7.758h4.039L171.3,68.6Zm2.037,4.154c.29,1.128.6,2.3,1,3.564l2.313,6.7h-6.583l2.281-6.743c.347-1.093.677-2.274.985-3.52",
    transform: "translate(-90.019 -38.973)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M221.1,83.761a7.152,7.152,0,0,0-6.077,2.915l-.152-2.513h-3.5l.021.321c.1,1.565.146,3.289.146,5.762V109.72h3.823v-9.088a6.712,6.712,0,0,0,5.225,2.245,7.88,7.88,0,0,0,5.792-2.462,10.445,10.445,0,0,0,2.557-7.352,10.168,10.168,0,0,0-2.221-6.713,7.273,7.273,0,0,0-5.618-2.589m-.952,3.165c3.408,0,4.933,3.156,4.933,6.285,0,4.034-1.946,6.54-5.078,6.54a4.634,4.634,0,0,1-4.5-3.547,4.877,4.877,0,0,1-.136-1.237V91.892a5.751,5.751,0,0,1,.121-.944c.019-.1.04-.209.055-.31a4.84,4.84,0,0,1,4.608-3.713",
    transform: "translate(-120.093 -47.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M266.68,83.761a7.155,7.155,0,0,0-6.077,2.915l-.152-2.513h-3.495l.019.321c.1,1.567.148,3.289.148,5.762V109.72h3.823v-9.088a6.709,6.709,0,0,0,5.224,2.245,7.889,7.889,0,0,0,5.794-2.462,10.454,10.454,0,0,0,2.556-7.352A10.169,10.169,0,0,0,272.3,86.35a7.27,7.27,0,0,0-5.617-2.589m-.951,3.165c3.406,0,4.931,3.156,4.931,6.285,0,4.034-1.947,6.54-5.077,6.54a4.634,4.634,0,0,1-4.5-3.547,4.881,4.881,0,0,1-.135-1.237V91.892a5.627,5.627,0,0,1,.122-.947c.019-.1.038-.206.055-.307a4.837,4.837,0,0,1,4.607-3.713",
    transform: "translate(-145.99 -47.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M324.6,78.77c-3.568-1.381-4.71-2.468-4.71-4.475,0-1.69,1.343-3.4,4.344-3.4a8.688,8.688,0,0,1,4.487,1.127l.324.2,1.079-3.19-.213-.125a11.079,11.079,0,0,0-5.566-1.249c-4.875,0-8.279,2.878-8.279,7,0,3.322,2.132,5.644,6.709,7.308,3.244,1.213,4.451,2.455,4.451,4.584,0,2.41-1.863,3.905-4.859,3.905a10.46,10.46,0,0,1-5.509-1.562l-.331-.212L315.5,91.946l.188.125a13.093,13.093,0,0,0,6.46,1.661c6.57,0,8.9-4.006,8.9-7.436,0-3.537-1.868-5.718-6.448-7.525",
    transform: "translate(-179.256 -38.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M358.9,74.613l-3.749,1.177v3.175H352.4V82.02h2.744v9.358c0,2.262.433,3.848,1.324,4.85a4.9,4.9,0,0,0,3.7,1.452,8.992,8.992,0,0,0,2.955-.456l.214-.076-.183-3.06-.367.112a5.756,5.756,0,0,1-1.778.206c-1.481,0-2.114-.937-2.114-3.137V82.02h4.611V78.966H358.9Z",
    transform: "translate(-200.22 -42.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M388.1,83.761c-5.348,0-9.083,3.992-9.083,9.7,0,5.542,3.614,9.412,8.79,9.412h.035c4.376,0,9.083-3.048,9.083-9.741a9.661,9.661,0,0,0-2.436-6.761,8.506,8.506,0,0,0-6.39-2.614m-.111,3.018c3.439,0,5,3.352,5,6.469,0,3.832-2.136,6.613-5.077,6.613h-.037c-2.9,0-5-2.735-5-6.5,0-3.274,1.581-6.579,5.113-6.579",
    transform: "translate(-215.343 -47.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M435.085,83.938l-.229-.058a3.682,3.682,0,0,0-.95-.119,5.451,5.451,0,0,0-4.793,3.077L429,84.163h-3.43l.022.321c.1,1.513.144,3.212.144,5.5l-.035,12.487h3.822V92.734a9.853,9.853,0,0,1,.105-1.482c.431-2.34,2.01-3.852,4.022-3.852a9.786,9.786,0,0,1,1.026.064l.409.042Z",
    transform: "translate(-241.79 -47.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M456.133,83.677c-5.088,0-8.643,4.066-8.643,9.888,0,5.606,3.536,9.229,9.009,9.229a14.665,14.665,0,0,0,6.052-1.161l.23-.1-.735-2.848-.319.129a11.844,11.844,0,0,1-4.789.856c-1.661,0-5.491-.548-5.725-5.542l12.338.037.05-.244a8.55,8.55,0,0,0,.114-1.6c0-3.988-1.985-8.644-7.582-8.644m-.255,2.908a3.772,3.772,0,0,1,2.806,1.071A5.44,5.44,0,0,1,460,91.214h-8.718c.355-2.208,1.736-4.629,4.6-4.629",
    transform: "translate(-254.244 -47.542)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M158.44,28.3a27.87,27.87,0,0,1,3.667-.248c2.464,0,4.219.5,5.382,1.473a5.233,5.233,0,0,1,1.892,4.311,6.054,6.054,0,0,1-1.911,4.648c-1.262,1.118-3.313,1.721-5.9,1.721a26.612,26.612,0,0,1-3.135-.142ZM160.175,38.9a12.39,12.39,0,0,0,1.736.071c3.666.017,5.657-1.845,5.657-5.074.019-2.856-1.755-4.613-5.381-4.613a10.9,10.9,0,0,0-2.011.16Z",
    transform: "translate(-90.018 -15.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M192,44.591a4.31,4.31,0,0,1-4.573-4.417,4.429,4.429,0,0,1,4.731-4.559,4.275,4.275,0,0,1,4.593,4.4,4.445,4.445,0,0,1-4.73,4.577Zm.059-1.171a3.055,3.055,0,0,0,2.9-3.353c0-1.454-.808-3.282-2.858-3.282-2.031,0-2.918,1.7-2.918,3.335a3.006,3.006,0,0,0,2.858,3.3Z",
    transform: "translate(-106.485 -20.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M213.034,36.065l1.281,4.347c.256.958.513,1.863.69,2.75h.059c.217-.87.532-1.792.848-2.732l1.557-4.365h1.459l1.479,4.293c.354,1.012.63,1.934.847,2.8h.059a23.768,23.768,0,0,1,.729-2.786l1.36-4.311h1.715l-3.075,8.587h-1.577l-1.458-4.1a28.255,28.255,0,0,1-.849-2.839h-.039a23.693,23.693,0,0,1-.868,2.857l-1.537,4.08h-1.577l-2.879-8.587Z",
    transform: "translate(-120.028 -20.491)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M247.266,38.133c0-.905-.02-1.614-.079-2.325h1.538l.1,1.4h.04a3.615,3.615,0,0,1,3.154-1.6c1.321,0,3.371.71,3.371,3.655V44.4h-1.734v-4.95c0-1.384-.573-2.554-2.208-2.554a2.475,2.475,0,0,0-2.326,1.6,2.105,2.105,0,0,0-.118.728V44.4h-1.735Z",
    transform: "translate(-140.441 -20.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_378",
    "data-name": "Rectangle 378",
    width: 1.735,
    height: 12.596,
    transform: "translate(117.766 11.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M286.363,44.591a4.31,4.31,0,0,1-4.573-4.417,4.429,4.429,0,0,1,4.731-4.559,4.276,4.276,0,0,1,4.593,4.4,4.445,4.445,0,0,1-4.731,4.577Zm.058-1.171a3.055,3.055,0,0,0,2.9-3.353c0-1.454-.808-3.282-2.858-3.282-2.031,0-2.918,1.7-2.918,3.335a3.006,3.006,0,0,0,2.859,3.3Z",
    transform: "translate(-160.1 -20.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M314.186,42.338a13,13,0,0,0,.138,2.058h-1.558l-.158-1.082h-.058a3.668,3.668,0,0,1-2.918,1.277c-1.932,0-2.918-1.224-2.918-2.466,0-2.075,2.05-3.211,5.735-3.193v-.177c0-.709-.216-2-2.167-1.986a4.982,4.982,0,0,0-2.5.638l-.395-1.046a6.717,6.717,0,0,1,3.154-.745c2.937,0,3.647,1.791,3.647,3.512Zm-1.695-2.324c-1.893-.035-4.041.266-4.041,1.934a1.45,1.45,0,0,0,1.616,1.49A2.406,2.406,0,0,0,312.412,42a1.435,1.435,0,0,0,.079-.5Z",
    transform: "translate(-174.262 -20.235)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M337.784,26.782V37.16c0,.763.021,1.632.079,2.218h-1.557l-.079-1.49h-.04a3.569,3.569,0,0,1-3.233,1.685,4.094,4.094,0,0,1-4.1-4.364,4.281,4.281,0,0,1,4.277-4.613,3.282,3.282,0,0,1,2.879,1.3h.039V26.782Zm-1.734,7.5a2.589,2.589,0,0,0-.079-.674,2.507,2.507,0,0,0-2.5-1.792c-1.794,0-2.859,1.419-2.859,3.3,0,1.756.967,3.192,2.82,3.192a2.58,2.58,0,0,0,2.542-1.862,2.419,2.419,0,0,0,.079-.674Z",
    transform: "translate(-186.84 -15.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M368.851,44.591a4.31,4.31,0,0,1-4.573-4.417,4.43,4.43,0,0,1,4.731-4.559,4.275,4.275,0,0,1,4.593,4.4,4.445,4.445,0,0,1-4.73,4.577Zm.06-1.171a3.055,3.055,0,0,0,2.9-3.353c0-1.454-.807-3.282-2.858-3.282-2.031,0-2.918,1.7-2.918,3.335a3.006,3.006,0,0,0,2.858,3.3Z",
    transform: "translate(-206.966 -20.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M390.836,38.133c0-.905-.02-1.614-.079-2.325h1.538l.1,1.4h.038a3.614,3.614,0,0,1,3.154-1.6c1.321,0,3.371.71,3.371,3.655V44.4h-1.735v-4.95c0-1.384-.571-2.554-2.208-2.554a2.478,2.478,0,0,0-2.326,1.6,2.126,2.126,0,0,0-.118.728V44.4h-1.734Z",
    transform: "translate(-222.011 -20.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M426.617,31.3v2.057H429.1v1.188h-2.483v4.631c0,1.064.336,1.667,1.3,1.667a3.594,3.594,0,0,0,1.005-.106L429,41.928a5.21,5.21,0,0,1-1.537.213,2.628,2.628,0,0,1-1.873-.656,3.117,3.117,0,0,1-.67-2.254V34.548h-1.479V33.359h1.479V31.78Z",
    transform: "translate(-240.581 -17.784)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M441.064,26.782H442.8v5.357h.04a2.95,2.95,0,0,1,1.242-1.1,3.665,3.665,0,0,1,1.774-.444c1.28,0,3.331.71,3.331,3.672v5.109h-1.734V34.446c0-1.4-.572-2.555-2.208-2.555a2.494,2.494,0,0,0-2.326,1.561,1.713,1.713,0,0,0-.119.745v5.18h-1.734Z",
    transform: "translate(-250.593 -15.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M466.477,40.345c.041,2.111,1.519,2.981,3.253,2.981a7.23,7.23,0,0,0,2.642-.426l.316,1.1a8.532,8.532,0,0,1-3.194.55c-2.919,0-4.692-1.757-4.692-4.328a4.372,4.372,0,0,1,4.494-4.648,3.758,3.758,0,0,1,3.923,4.045,3.607,3.607,0,0,1-.058.745Zm5.067-1.118a2.3,2.3,0,0,0-2.385-2.537,2.7,2.7,0,0,0-2.661,2.537Z",
    transform: "translate(-264.08 -20.211)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreIcon);
export default __webpack_public_path__ + "static/media/appStoreIcon.97207fa6c5eb58c6db5bcde567795e2b.svg";
export { ForwardRef as ReactComponent };